import {
  provideTransloco,
  TranslocoModule
} from '@jsverse/transloco';
import { NgModule } from '@angular/core';
import { Translation, TranslocoLoader } from "@jsverse/transloco";
import { TranslocoHttpLoader } from './transloco-loader';
import { environment } from '../../environments/environment';

@NgModule({
  exports: [ TranslocoModule ],
  providers: [
      provideTransloco({
        config: {
          availableLangs: ['en', 'es'],
          defaultLang: 'es',
          // Remove this option if your application doesn't support changing language in runtime.
          reRenderOnLangChange: true,
          prodMode: false
        },
        loader: TranslocoHttpLoader
      }),
  ],
})
export class TranslocoRootModule {}
